<template>
  <div class="question-content">
    <v-container fluid grid-list-md>
      <wes-q-text v-bind:metadata="question"></wes-q-text>

      <div id="q11Errs" style="width:100%;height:15px;"></div>
      <err-panel v-if="bDisplayErrors===true" v-on:closepanel="onClosePanel" v-bind:errors="errorList" v-on:closeerrorpanel="onErrorPanelCleared"></err-panel>

      <v-layout row wrap>
        <v-flex xs12>
          <div class="clearfix buttons-container">
            <v-btn class="button" rounded color="primary" dark :curentAnswer="currentAnswer" @click="onFillZerosClicked(currentAnswer)">Fill With Zeros</v-btn>
          </div>
        </v-flex>
      <v-flex lg12><hr /><br /></v-flex>
      </v-layout>

      <v-layout row wrap>
        <!-- COLUMN HEADERS -->
        <!-- CATEGORY HEADER -->
        <v-flex xs6>
          <p class="column-header">{{ colHeaders[0].colLabel }}</p>
        </v-flex>
        <!-- DATA HEADERS -->
        <v-flex v-for="colHeaders in filteredColHeaders" :key="colHeaders.colHeader" xs2>
          <p class="column-header">{{ colHeaders.colHeader }}<br />{{ colHeaders.colLabel }}</p>
        </v-flex>
      </v-layout>

      <v-layout v-for="(category, categoryIndex) in this.labels" :key="category.categoryHeading" row wrap>
        <!-- ROWS WITH NO SUBCATEGORIES -->
        <v-layout v-if="category.subs == ''" row wrap>
          <v-flex xs6>
            <p class="row-header">{{ category.categoryHeading }}. {{ category.categoryLabel }}</p>
          </v-flex>

          <!-- Not the last category -->
          <v-flex v-if="categoryIndex != labels.length - 1" :currentAnswer="currentAnswer" xs2>
            <v-text-field v-model="currentAnswer[categoryIndex].answerFields[0][0]" prefix="$" suffix="" height="32" outline @change="updateAnswerValue(categoryIndex, 0, 0, $event)"></v-text-field>
          </v-flex>
          <!-- The last category (with totals) -->
          <v-flex v-else :currentAnswer="currentAnswer" xs2>
            <v-text-field :value="grandRowsTotals(0)" @change="q11Updated(grandRowsTotals(0))" prefix="$" suffix="" height="32" readonly outline></v-text-field>
          </v-flex>

          <!-- Not the last category -->
          <v-flex v-if="categoryIndex != labels.length - 1" :currentAnswer="currentAnswer" xs2>
            <v-text-field v-model="currentAnswer[categoryIndex].answerFields[0][1]" prefix="$" suffix="" height="32" outline @change="updateAnswerValue(categoryIndex, 0, 1, $event)"></v-text-field>
          </v-flex>
          <!-- The last category (with totals) -->
          <v-flex v-else :currentAnswer="currentAnswer" xs2>
            <v-text-field :value="grandRowsTotals(1)" @change="q11Updated(grandRowsTotals(1))" prefix="$" suffix="" height="32" readonly outline></v-text-field>
          </v-flex>

          <!-- Not the last category -->
          <v-flex v-if="categoryIndex != labels.length - 1" :currentAnswer="currentAnswer" xs2>
            <v-text-field :value="totalCols(categoryIndex, 0, 2)" prefix="$" suffix="" height="32" readonly outline></v-text-field>
          </v-flex>
          <!-- The last category (with totals) -->
          <v-flex v-else :currentAnswer="currentAnswer" xs2>
            <v-text-field :value="grandTotalComputedRows(2)" @change="q11Updated(grandRowsTotals(2))" prefix="$" suffix="" height="32" readonly outline></v-text-field>
          </v-flex>

        </v-layout>

        <!-- ROWS WITH SUBCATEGORIES -->

        <v-layout v-else row wrap>
          <v-flex xs12>
            <p class="row-header">{{ category.categoryHeading }}. {{ category.categoryLabel }}</p>
          </v-flex>
          <v-layout v-for="(dataRows, dataRowsIndex) in category.subs" :key="dataRows.colHeader" row wrap>
            <v-flex xs6>
              <p class="row-label">{{ dataRows.subHeading }}. {{ dataRows.subLabel }}</p>
            </v-flex>

            <v-flex :currentAnswer="currentAnswer" xs2>
              <v-text-field v-model="currentAnswer[categoryIndex].answerFields[dataRowsIndex][0]" prefix="$" suffix="" height="32" outline @change="updateAnswerValue(categoryIndex, dataRowsIndex, 0, $event)"></v-text-field>
            </v-flex>

            <v-flex :currentAnswer="currentAnswer" xs2>
              <v-text-field v-model="currentAnswer[categoryIndex].answerFields[dataRowsIndex][1]" prefix="$" suffix="" height="32" outline @change="updateAnswerValue(categoryIndex, dataRowsIndex, 1, $event)"></v-text-field>
            </v-flex>

            <v-flex :currentAnswer="currentAnswer" xs2>
              <v-text-field :value="totalCols(categoryIndex, dataRowsIndex, 2)" prefix="$" suffix="" height="32" readonly outline></v-text-field>
            </v-flex>
          </v-layout>

        </v-layout>

      </v-layout>

      <br /><br />

      <answer-explain :label="question.explanation.label" v-bind:explaination="x"></answer-explain>

      <v-layout row wrap>
        <v-flex xs2><v-icon class="help-ico" v-on:click="onHandleHelpClicked(true)">fa fa-question-circle</v-icon></v-flex>
        <v-flex xs10>
          <div class="clearfix buttons-container">
            <v-btn class="button" rounded color="primary" dark v-on:click="onSaveClicked">Save</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <help-panel v-if="bDisplayHelp===true" v-on:closepanel="onClosePanel" v-bind:question="question.surveyQuestionInfo"></help-panel>
  </div>
</template>

<script>
import { answerService } from "../../services/answerService";
import { utilityService } from "../../services/utilityService";
import { errorService } from "../../services/errorService";
export default {
  name: 'Question6',
  props: {
    question: Object,
    qId: String
  },
  data: () => ({
    isHelpDisplayed: false,
    isErrorsOverlayDisplayed: false,
    x: '',
    colHeaders: [
      { colHeader: '', colLabel: 'Federal agency' },
      { colHeader: '(a)', colLabel: 'R&D conduct' },
      { colHeader: '(b)', colLabel: 'R&D plant' },
      { colHeader: '(c)', colLabel: 'Total R&D conduct and plant' }
    ],

    labels: [
      { categoryHeading: '1',
categoryLabel: 'Department of Agriculture',
        subs: ['']
      },
      { categoryHeading: '2',
categoryLabel: 'Department of Commerce',
        subs: ['']
      },
      { categoryHeading: '3',
categoryLabel: 'Department of Defense',
        subs: [
          { subHeading: 'a', subLabel: 'Department of the Air Force' },
          { subHeading: 'b', subLabel: 'Department of the Army' },
          { subHeading: 'c', subLabel: 'Department of the Navy' },
          { subHeading: 'd', subLabel: 'Other defense agencies' }
        ]
      },
      { categoryHeading: '4',
categoryLabel: 'Department of Education',
        subs: ['']
      },
      { categoryHeading: '5',
categoryLabel: 'Department of Energy',
        subs: ['']
      },
      { categoryHeading: '6',
categoryLabel: 'Department of Health and Human Services',
        subs: ['']
      },
      { categoryHeading: '7',
categoryLabel: 'Department of Homeland Security',
        subs: ['']
      },
      { categoryHeading: '8',
categoryLabel: 'Department of Housing and Urban Development',
        subs: ['']
      },
      { categoryHeading: '9',
categoryLabel: 'Department of the Interior',
        subs: ['']
      },
      { categoryHeading: '10',
categoryLabel: 'Department of Justice',
        subs: ['']
      },
      { categoryHeading: '11',
categoryLabel: 'Department of Labor',
        subs: ['']
      },
      { categoryHeading: '12',
categoryLabel: 'Department of State',
        subs: ['']
      },
      { categoryHeading: '13',
categoryLabel: 'Department of Transportation',
        subs: ['']
      },
      { categoryHeading: '14',
categoryLabel: 'Department of the Treasury',
        subs: ['']
      },
      { categoryHeading: '15',
categoryLabel: 'Department of Veterans Affairs',
        subs: ['']
      },
      { categoryHeading: '16',
categoryLabel: 'Administrative Office of the U.S. Courts',
        subs: ['']
      },
      { categoryHeading: '17',
categoryLabel: 'Agency for International Development',
        subs: ['']
      },
      { categoryHeading: '18',
categoryLabel: 'Appalachian Regional Commission',
        subs: ['']
      },
      { categoryHeading: '19',
categoryLabel: 'Consumer Product Safety Commission',
        subs: ['']
      },
      { categoryHeading: '20',
categoryLabel: 'Environmental Protection Agency',
        subs: ['']
      },
      { categoryHeading: '21',
categoryLabel: 'Federal Communications Commission',
        subs: ['']
      },
      { categoryHeading: '22',
categoryLabel: 'Federal Trade Commission',
        subs: ['']
      },
      { categoryHeading: '23',
categoryLabel: 'Library of Congress',
        subs: ['']
      },
      { categoryHeading: '24',
categoryLabel: 'National Aeronautics and Space Administration',
        subs: ['']
      },
      { categoryHeading: '25',
categoryLabel: 'National Archives and Records Administration',
        subs: ['']
      },
      { categoryHeading: '26',
categoryLabel: 'National Science Foundation',
        subs: ['']
      },
      { categoryHeading: '27',
categoryLabel: 'Nuclear Regulatory Commission',
        subs: ['']
      },
      { categoryHeading: '28',
categoryLabel: 'Patient-Centered Outcomes Research Trust Fund',
        subs: ['']
      },
      { categoryHeading: '29',
categoryLabel: 'Smithsonian Institution',
        subs: ['']
      },
      { categoryHeading: '30',
categoryLabel: 'Social Security Administration',
        subs: ['']
      },
      { categoryHeading: '31',
categoryLabel: 'Tennessee Valley Authority',
        subs: ['']
      },
      { categoryHeading: '32',
categoryLabel: 'U.S. Postal Service',
        subs: ['']
      },
      { categoryHeading: '33',
categoryLabel: 'Other department/agency (describe in text box below)',
        subs: ['']
      },
      { categoryHeading: '34',
categoryLabel: 'Total',
        subs: ['']
      }
    ],
    currentAnswer: [
      { answerCategory: '1', answerFields: [['1', '2', '']] },
      { answerCategory: '2', answerFields: [['3', '4', '']] },
      { answerCategory: '3', answerFields: [['5', '6', ''], ['7', '8', ''], ['9', '10', ''], ['11', '12', '']] },
      { answerCategory: '4', answerFields: [['13', '14', '']] },
      { answerCategory: '5', answerFields: [['15', '16', '']] },
      { answerCategory: '6', answerFields: [['17', '18', '']] },
      { answerCategory: '7', answerFields: [['19', '20', '']] },
      { answerCategory: '8', answerFields: [['21', '22', '']] },
      { answerCategory: '9', answerFields: [['23', '24', '']] },
      { answerCategory: '10', answerFields: [['25', '26', '']] },
      { answerCategory: '11', answerFields: [['27', '28', '']] },
      { answerCategory: '12', answerFields: [['29', '30', '']] },
      { answerCategory: '13', answerFields: [['31', '32', '']] },
      { answerCategory: '14', answerFields: [['33', '34', '']] },
      { answerCategory: '15', answerFields: [['35', '36', '']] },
      { answerCategory: '16', answerFields: [['37', '38', '']] },
      { answerCategory: '17', answerFields: [['39', '40', '']] },
      { answerCategory: '18', answerFields: [['41', '42', '']] },
      { answerCategory: '19', answerFields: [['43', '44', '']] },
      { answerCategory: '20', answerFields: [['45', '46', '']] },
      { answerCategory: '21', answerFields: [['47', '48', '']] },
      { answerCategory: '22', answerFields: [['49', '50', '']] },
      { answerCategory: '23', answerFields: [['51', '52', '']] },
      { answerCategory: '24', answerFields: [['53', '54', '']] },
      { answerCategory: '25', answerFields: [['55', '56', '']] },
      { answerCategory: '26', answerFields: [['57', '58', '']] },
      { answerCategory: '27', answerFields: [['59', '60', '']] },
      { answerCategory: '28', answerFields: [['61', '62', '']] },
      { answerCategory: '29', answerFields: [['63', '64', '']] },
      { answerCategory: '30', answerFields: [['65', '66', '']] },
      { answerCategory: '31', answerFields: [['67', '68', '']] },
      { answerCategory: '32', answerFields: [['69', '70', '']] },
      { answerCategory: '33', answerFields: [['71', '72', '']] },
      { answerCategory: '34', answerFields: [['73', '74', '']] }
    ]
  }),
  methods: {
    q11Updated: function (val) {
      // this.$emit("q11Totals", val);
    },
    onFillZerosClicked: function () {
      const categories = this.currentAnswer.length;
      for (var i = 0; i < categories; i++) {
        const rowsInCategory = this.currentAnswer[i].answerFields.length;
        for (var j = 0; j < rowsInCategory; j++) {
          const columns = this.currentAnswer[i].answerFields[j].length;
          for (var k = 0; k < columns; k++) {
            if (this.currentAnswer[i].answerFields[j][k] === '') {
              this.currentAnswer[i].answerFields[j][k] = 0;
              this.currentAnswer.push();
              // console.log('categories=' + categories + ' rowsInCategory=' + rowsInCategory + ' columns=' + columns)
            }
          }
        }
      }
    },
    updateAnswerValue: function (id, idx, item, val) {
      this.currentAnswer[id].answerFields[idx][item] = val;
    },
    onValueChanged: function (event) {
      console.log('On Value Changed.');
    },
    onSaveClicked: function () {
      console.log('Called save with: ' + this.currentAnswer);
      answerService.saveSurveyQuestionAnswer(0, this.$props.question.id, this.currentAnswer);
      this.errorList = errorService.runValidationForQuestion(this.$props.question.id);
      this.isErrorsOverlayDisplayed = true;
      utilityService.scrollElemIntoView('q11Errs');
    },
    onClosePanel: function () {
      this.isErrorsOverlayDisplayed = false;
      this.isHelpDisplayed = false;
    },
    onErrorPanelCleared: function () {
      this.isErrorsOverlayDisplayed = false;
    },
    onHandleHelpClicked: function (bDisplay) {
      this.isHelpDisplayed = bDisplay;
    },
    totalCols: function (category, subcategory, colTotal) {
      var total = 0;
      // console.log("one=" + one + ", two=" + two + ", three=" + three);
      var totalCols = colTotal;
      for (var i = 0; i < totalCols; i++) {
        total += utilityService.convertStringToNum(this.currentAnswer[category].answerFields[subcategory][i])
      }
      return total;
    },
    totalRows: function (category, colIndex) {
      var total = 0;
      var totalRows = this.currentAnswer[category].answerFields.length;
      for (var i = 0; i < totalRows; i++) {
        total += utilityService.convertStringToNum(this.currentAnswer[category].answerFields[i][colIndex])
      }
      return total;
    },
    totalComputedRows: function (category) {
      var total = 0;
      var totalRows = this.currentAnswer[category].answerFields.length;
      for (var i = 0; i < totalRows; i++) {
        var totalCols = this.currentAnswer[category].answerFields[i].length;
        for (var j = 0; j < totalCols; j++) {
          console.log("i=" + i + ", j=" + j + ", total=" + utilityService.convertStringToNum(this.currentAnswer[category].answerFields[i][j]));
          total += utilityService.convertStringToNum(this.currentAnswer[category].answerFields[i][j]);
        }
      }
      return total;
    },
    grandTotalComputedRows: function () {
      var total = 0;
      var totalCategories = this.currentAnswer.length;
      for (var h = 0; h < totalCategories; h++) {
        var totalRows = this.currentAnswer[h].answerFields.length;
        for (var i = 0; i < totalRows; i++) {
          var totalCols = this.currentAnswer[h].answerFields[i].length;
          for (var j = 0; j < totalCols; j++) {
            // console.log("h=" + h + ", i=" + i + ", j=" + j + ", total=" + utilityService.convertStringToNum(this.currentAnswer[category].answerFields[i][j]));
            total += utilityService.convertStringToNum(this.currentAnswer[h].answerFields[i][j]);
          }
        }
      }
      return total;
    },
    grandRowsTotals: function (col) {
      var total = 0;
      const colIndex = col;
      var totalCategories = this.currentAnswer.length;
      for (var i = 0; i < totalCategories; i++) {
        var totalSubs = this.currentAnswer[i].answerFields.length;
        for (var j = 0; j < totalSubs; j++) {
          total += utilityService.convertStringToNum(this.currentAnswer[i].answerFields[j][colIndex])
        }
      }
      return total;
    },
    grandRowsTotalsCrossCheck: function (col) {
      var total = 0;
      const colIndex = col;
      var totalCategories = this.crossCheckAnswer.length;
      for (var i = 0; i < totalCategories; i++) {
        var totalSubs = this.crossCheckAnswer[i].answerFields.length;
        for (var j = 0; j < totalSubs; j++) {
          total += utilityService.convertStringToNum(this.crossCheckAnswer[i].answerFields[j][colIndex])
        }
      }
      return total;
    },
    total3: function (num1, num2, num3) {
      return num1 + num2 + num3;
    },
    getValues: function (val1, val2) {
      console.log("Val1=" + val1 + " Val2=" + val2);
    }
  },
  computed: {
		bDisplayHelp: function () {
			return this.isHelpDisplayed;
		},
		bDisplayErrors: function () {
			return this.isErrorsOverlayDisplayed;
    },
    filteredColHeaders () {
      return this.colHeaders.slice(1, 4);
    }
  }
};
</script>

<style scoped>
.header {
  font-weight: bold;
}
.column-header {
  font-weight: bold;
  font-size: 16px;
  text-align: center;
}
.row-header {
  line-height: 60px;
  font-weight: bold;
  font-size: 16px;
}
.question-content {
  text-align: left;
  /* background-color: #598dc233; */
  /* border: 2px solid #13314f; */
  /* border-radius: 5px; */
  /* position: relative; */
  color: black;
}
.question-content > h1 {
  margin: 5px 0;
}
.question-content > p,
.question-content > ul {
  margin: 5px 10px;
}
.value-list {
  list-style: lower-latin;
}
.row-label {
  line-height: 60px;
  font-weight: bold;
  font-size: 16px;
  margin-left: 20px
}
.buttons-container > .button {
  float: right;
}
.v-text-field--outline > .v-input__control > .v-input__slot {
  background-color: purple;
}
.v-input--is-focused > .v-input__control > .v-input__slot {
  border: 2px solid red;
}
.help-ico {
  font-size: 40px;
  line-height: 44px;
  color: #0000ffa3;
}
.bordered {
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.3);
  border-width: 1px 1px 1px 2px;
}
.indented1 {
  margin-left: 25pt;
  font-weight: normal;
}
.indented2 {
  margin-left: 50pt;
  font-weight: normal;
}
</style>
